module.exports = __webpack_public_path__ + "img/RedBullDisabeld.0b7c0010.svg";